import React, { useEffect, useRef, useState } from "react";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import TabsClassic from "src/components/TabsClassic";
import { classResponsiveFormDoubleWidth, ERRORFIELDREQUIRED, optionsYesNoResponse } from "src/data/ConstantForm";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "src/assets/colors/Colors";
import { useDispatch } from "react-redux";
import { GlobalConstants } from "src/data/GlobalConstants";
import SelectFormVirtualize from "src/components/ComponentesFormularios/SelectFormVirtualize";
import Tabs from "src/components/Tabs";
import ImagePickerCrop from "src/components/ImagePickerCrop";
import { modalCRUDService } from "src/services/modalCRUDService";
import { clientesService } from "src/services/unoauno/apiClientes";
import { dateToStringFormat, getCurrentTime, getFechaToCalendarRange, toBlob } from "src/util/functions";
import SelectForm from "src/components/ComponentesFormularios/SelectForm";
import { CalendarFormRange } from "src/components/ComponentesFormularios/CalendarForm";
import "./styles.css"
import { alertQuestionService } from "src/services/alertQuestionService";
import { bannersService } from "src/services/unoauno/apiBanners";

const FormCRUDBanners = ({properties}) => {
    const dispatch = useDispatch();

    const { data: { 
        proveedor,
        dataBanner, 
        canales, 
        negocios, 
        segmentaciones, 
        segmentacionesProveedores, 
        tipologias, 
        productos, 
        categorias,
        paises,
        agencias,
        distribuidoras,
        zonas,
        edit,
        arbolTerritorial,
        reload
    } } = properties;

    const methods = useForm({defaultValues: {
        descripcion: edit ? dataBanner.descripcion : '',
        orden: edit ? dataBanner.orden : '',
        evento: edit ? dataBanner.evento : '',
        fecha: edit ? getFechaToCalendarRange(dataBanner.fechaInicio, dataBanner.fechaFin) : getFechaToCalendarRange(dateToStringFormat(new Date()), dateToStringFormat(new Date())),
        productosAsignados: edit && dataBanner.idProducto ? dataBanner?.idProducto?.split(",") : [],
        categoriaAsignada: edit ? dataBanner.idCategoria : "",
    }});

    const { control, setValue, handleSubmit, formState: { errors } } = methods;
    const [stateTab, setStateTab] = useState("");

    const [objetivos, setObjetivos] = useState(dataBanner.objetivosEnvio ?? []);
    const [urlImagen, setUrlImagen] = useState(edit ? dataBanner.urlBanner ?? '' : '');
    const previewRef = useRef(null);

    const onClickGuardar = async (data) => {
        let idBanner = dataBanner.id;
        data.orden ||= "0";

        if(urlImagen == '' && !previewRef.current) return dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes agregar una imagen' } });

        if(objetivos.length == 0) return dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes agregar al menos un objetivo de envio' } });
        
        try {
            if(edit) {
                await bannersService.updateBanner({
                    id: dataBanner.id,
                    descripcion: data.descripcion,
                    idProducto: data?.productosAsignados?.length > 0 ? data.productosAsignados.join(",") : null,
                    idCategoria: data?.categoriaAsignada == "" ? null : data.categoriaAsignada,
                    fechaInicio: dateToStringFormat(data.fecha[0]),
                    fechaFin: dateToStringFormat(data.fecha[1]),
                    evento: data.evento,
                    orden: data.orden,
                    objetivosEnvio: objetivos.map(el => {
                        return {
                            division_territorial_id: el.idDivisionTerritorial ? el.idDivisionTerritorial.toString() : "0",
                            punto_venta: el.idCliente ? el.idCliente.toString() : "",
                            canal: el.canal ? el.canal.toString() : "",
                            negocio_id: el.idNegocio ? el.idNegocio.toString() : "",
                            tipologia: el.tipologia ? el.tipologia.toString() : "",
                            segmento: el.segmento ? el.segmento.toString() : "",
                            segmento_general: el.idSegmentacion ? el.idSegmentacion.toString() : "",
                        }
                    })
                });
            }else {
                const response = await bannersService.saveBanner({
                    proveedor,
                    descripcion: data.descripcion,
                    idProducto: data?.productosAsignados?.length > 0 ? data.productosAsignados.join(",") : null,
                    idCategoria: data?.categoriaAsignada == "" ? null : data.categoriaAsignada,
                    fechaInicio: dateToStringFormat(data.fecha[0]),
                    fechaFin: dateToStringFormat(data.fecha[1]),
                    evento: data.evento,
                    orden: data.orden,
                    objetivosEnvio: objetivos.map(el => {
                        return {
                            division_territorial_id: el.idDivisionTerritorial ? el.idDivisionTerritorial.toString() : "0",
                            punto_venta: el.idCliente ? el.idCliente.toString() : "",
                            canal: el.canal ? el.canal.toString() : "",
                            negocio_id: el.idNegocio ? el.idNegocio.toString() : "",
                            tipologia: el.tipologia ? el.tipologia.toString() : "",
                            segmento: el.segmento ? el.segmento.toString() : "",
                            segmento_general: el.idSegmentacion ? el.idSegmentacion.toString() : "",
                        }
                    })
                });

                idBanner = response.data;
            }
            
            if(previewRef?.current) {
                const nombreImg = `bn_${idBanner}_${getCurrentTime()}.png`
                
                const blobImg = await toBlob(previewRef.current);
                const file = new File([blobImg], nombreImg);

                await bannersService.saveImagen({file: file, idBanner: idBanner, nombreImg, extension: "/banners"})
            }

            reload();
            modalCRUDService.clear();

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
        } catch (error) {
            console.log(error);
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'Ha ocurrido un error, comunicate con soporte' } });
        }
    }

    const onError = (err) => {
        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes agregar todos los campos requeridos' } });
    }

    return (
        <FormProvider {...methods}>
            <div className="p-2">
                <Tooltip title="Agregar" aria-label="agregar" style={{position: "absolute", right: "3.5%"}}>
                    <a onClick={handleSubmit(onClickGuardar, onError)} className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                        <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                    </a>
                </Tooltip>
                <div className="d-flex align-items-center">
                    <TabsClassic tabs={[
                        {
                            id: 1,
                            label: "Información general",
                            content: <InformacionGeneral
                                productos={productos}
                                categorias={categorias}
                                previewRef={previewRef}
                                urlImagen={urlImagen}

                                setValue={setValue}
                                setStateTab={setStateTab}
                                errors={errors}
                                control={control} 
                                dispatch={dispatch}
                            />
                        },
                        {
                            id: 2,
                            label: "Objetivos de envío",
                            content: <ObjetivosEnvio
                                control={control}

                                canales={canales}
                                tipologias={tipologias}
                                segmentacionesProveedores={segmentacionesProveedores}
                                
                                paises={paises}
                                agencias={agencias}
                                distribuidoras={distribuidoras}
                                zonas={zonas}
                                negocios={negocios}
                                segmentaciones={segmentaciones}

                                arbolTerritorial={arbolTerritorial}
                                setObjetivos={setObjetivos}
                                objetivos={objetivos}
                            />
                        }
                    ]} initialState={1} />
                </div>
            </div>
        </FormProvider>
    )
};

const InformacionGeneral = ({ productos, categorias, previewRef, urlImagen, setValue, setStateTab, errors, control, dispatch }) => {
    
    return (
        <div className="container mx-0 px-0 w-100 mw-100">
            <div className="w-100 row m-0 px-2 d-flex position-relative" style={{gap: "7px"}}>
                <InputForm
                    inputProps={{ control }}
                    identificador="orden" 
                    label="Orden"
                    placeholder=""
                    type="number"
                    required={false}
                    textUppercase={false}
                    className="px-2 col-2"
                />

                <SelectForm
                    inputProps={{control}}
                    identificador="evento" 
                    label="Banner Evento"
                    options={optionsYesNoResponse}  
                    showId={false}
                    required={true}
                    className="px-2 col-2"
                    customError={errors.evento ? ERRORFIELDREQUIRED : null}
                    style={errors.evento ? { marginBottom: 0 } : ''}
                />
                
                <CalendarFormRange
                    inputProps={{ control }}
                    disabled={false}
                    identificador="fecha" 
                    label="Fecha de activación"
                    required={true}
                    className="w-auto mb-2"
                />
            </div>

            <div className="w-100 mt-2 px-2">
                <InputForm
                    inputProps={{ control }}
                    identificador="descripcion" 
                    label="Descripción"
                    placeholder=""
                    multiline={true}
                    required={false}
                    textUppercase={false}
                    className="px-2 col-6"
                    customError={errors.descripcion ? "La longitud máxima del campo es de 300 caracteres" : null} rules={{ maxLength: 300}}
                    style={errors.descripcion ? { marginBottom: 0 } : ''}
                />
            </div>

            <div className="w-75 mt-3">
                <Tabs tabs={[
                    {   
                        show: true,
                        text: "Asignar categoría",
                        value: "categoria",
                        icon: "fas fa-shapes",
                        component: <AsignarCategoria
                            categorias={categorias}
                            control={control}
                            setValue={setValue}
                        />
                    },
                    {
                        show: true, 
                        text: `Asignar productos`,
                        value: "Productos",
                        icon: "fas fa-star",
                        component: <AsignarProductos
                            productos={productos}
                            control={control}
                            setValue={setValue}
                            dispatch={dispatch}
                        />
                    }
                ]} defaultValue="categoria" setStateTab={setStateTab} />
            </div>

            <div className="w-100 px-4">
                <ImagePickerCrop previewRef={previewRef} urlImagen={urlImagen} ratio={1.8}/>
            </div>
        </div>
    )
}

const AsignarCategoria = ({ categorias, control, setValue }) => {
    const categoriesSelect = useWatch({ control, name: "categoria" });
    const categoriaAsignada = useWatch({ control, name: "categoriaAsignada" });
    const productosAsignados = useWatch({ control, name: "productosAsignados" });

    const addCategoria = () => {
        if(!categoriesSelect) return

        if(productosAsignados.length > 0) {
            alertQuestionService.showAlert({
                title: `Varios elementos asignados`, question: `¿Deseas eliminarlos?`,
                message: `Al asignar una categoría se eliminarán los productos asignados`,
    
                actionBtnAceptar: () => {
                    alertQuestionService.clear();
                    setValue("productosAsignados", [])
                    setValue("categoriaAsignada", categoriesSelect.id)
                    setValue("categoria", null)
                },
                actionBtnCancelar: () => alertQuestionService.clear(),
                type: GlobalConstants.alertInfo
            })
        }else {
            setValue("categoriaAsignada", categoriesSelect.id)
            setValue("categoria", null)
        }
    }

    const eliminarCategoria = () => setValue("categoriaAsignada", "")

    return (
        <div className="w-100">
            <div className="d-flex position-relative align-items-center">
                <SelectFormVirtualize
                    isMulti={false}
                    inputProps={{ control }}
                    disabled={false}
                    showId={false}
                    identificador="categoria"
                    label="Categoría"
                    options={categorias}
                    required={false}
                    className="px-2 col-6"
                />

                <Tooltip title="Agregar" aria-label="agregar" style={{marginLeft: "10px"}} >
                    <a onClick={addCategoria} className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                        <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-plus fa-2x"/>
                    </a>
                </Tooltip>
            </div>

            <div className="w-100 px-2 mt-2">
                <strong>Categoría asignada:</strong>

                <div className="w-100 row m-0 p-0">
                    {categoriaAsignada ? (
                        <div className="containerTag">
                            <span>{categoriaAsignada}</span>
                            <i className="fas fa-times" onClick={eliminarCategoria}/>
                        </div>
                        ): 
                        <div className="px-2 mt-1">
                            <p>No hay categorias asignadas</p>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}

const AsignarProductos = ({ productos, control, setValue, dispatch }) => {
    const productsSelect = useWatch({ control, name: "productos" });
    const productosAsignados = useWatch({ control, name: "productosAsignados" });
    const categoriaAsignada = useWatch({ control, name: "categoriaAsignada" });

    const addProductos = () => {
        if(!productsSelect) return

        if(categoriaAsignada) {
            alertQuestionService.showAlert({
                title: `Varios elementos asignados`, question: `¿Deseas eliminarlas?`,
                message: `Al asignar un producto se eliminaran las categoria asignada`,
    
                actionBtnAceptar: () => {
                    alertQuestionService.clear();
                    setValue("categoriaAsignada", "")
                    add()
                },
                actionBtnCancelar: () => alertQuestionService.clear(),
                type: GlobalConstants.alertInfo
            })
            return
        }

        add()
    }

    const add = () => {
        if (!productosAsignados.includes(productsSelect.id)) {
            setValue("productosAsignados", [...productosAsignados, productsSelect.id])
            setValue("productos", null)
        }else {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: 'El producto ya se encuentra asignado' } });
        }
    }

    const eliminarProducto = (id) => setValue("productosAsignados", productosAsignados.filter(pro => pro != id))

    return (
        <div className="w-100">
            <div className="d-flex position-relative align-items-center">
                <SelectFormVirtualize
                    isMulti={false}
                    inputProps={{ control }}
                    disabled={false}
                    showId={true}
                    identificador="productos"
                    label="Productos"
                    options={productos}
                    required={false}
                    className="px-2 col-6"
                />

                <Tooltip title="Agregar" aria-label="agregar" style={{marginLeft: "10px"}} >
                    <a onClick={addProductos} className="icon-container-actions d-flex">
                        <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                        <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-plus fa-2x"/>
                    </a>
                </Tooltip>
            </div>

            <div className="w-100 px-2 mt-2">
                <strong>Productos asignados:</strong>

                <div className="w-100 row m-0 p-0">
                    {productosAsignados.length > 0 ? 
                        productosAsignados.map(( pro, index ) => 
                            <div key={index} className="containerTag">
                                <span>{pro}</span>
                                <i className="fas fa-times" onClick={() => eliminarProducto(pro)}/>
                            </div>
                        ): 
                        <div className="px-2 mt-1">
                            <p>No hay productos asignados</p>    
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}
   
const ObjetivosEnvio = ({ 
    control,
    canales, 
    tipologias, 
    segmentaciones, 
    segmentacionesProveedores, 
    negocios,
    paises,
    agencias,
    distribuidoras,
    zonas,
    arbolTerritorial,
    setObjetivos,
    objetivos
}) => {

    const eliminarObjetivo = (index) => {
        let newObjectivos = [...objetivos]
        newObjectivos.splice(index, 1)
        setObjetivos(newObjectivos)
    }

    const getNameObjetivosDeEnvio = (objetivosDeEnvio) => {
        return objetivosDeEnvio.map(objetivo => {
            if(objetivo.type == 1) {
                let nameObjetivo = "A todos"

                arbolTerritorial.forEach(pais => {
                    if(pais.id == objetivo.idDivisionTerritorial) return nameObjetivo = getNombreTopic({name: pais.nombre, objetivo})

                    pais.Agencias.forEach(agencia => {
                        if(agencia.id == objetivo.idDivisionTerritorial) return nameObjetivo = getNombreTopic({name: `${pais.nombre}_${agencia.nombre}`, objetivo})
                        
                        agencia.Distribuidoras.forEach(dist => {
                            if(dist.id == objetivo.idDivisionTerritorial) return nameObjetivo = getNombreTopic({name: `${pais.nombre}_${agencia.nombre}_${dist.nombre}`, objetivo})

                            dist.Zonas.forEach(zona => {
                                if(zona.id == objetivo.idDivisionTerritorial) return nameObjetivo = getNombreTopic({name: `${pais.nombre}_${agencia.nombre}_${dist.nombre}_${zona.nombre}`, objetivo})
                            })
                        })
                    })
                })

                return nameObjetivo
            }

            if(objetivo.type == 2) {
                return `${negocios.find(ne => ne.id == objetivo.idNegocio)?.text}_${objetivo.idCliente}`
            }

            if(objetivo.type == 3) {
                return `Segmentacion_${segmentaciones.find(se => se.id == objetivo.idSegmentacion)?.text}`
            }
        });
    }

    const getNombreTopic = ({name, objetivo}) => {
        const nameCanal = canales.find(ca => ca.id == objetivo.canal);
        const nameTipologia = tipologias.find(ti => ti.id == objetivo.tipologia);
        const nameSegmentacion = segmentacionesProveedores.find(se => se.id == objetivo.segmento);

        if(nameCanal) name = name.concat(nameCanal.topic ? `_${nameCanal.topic}` : "");
        if(nameTipologia) name = name.concat(nameTipologia.topic ? `_${nameTipologia.topic}` : "");
        if(nameSegmentacion) name = name.concat(nameSegmentacion.topic ? `_${nameSegmentacion.topic}` : "");

        return name
    }

    return (
        <div className="container mx-0 px-0 w-100 mw-100">
            <div className="w-100 row m-0 px-2 d-flex align-items-center position-relative" style={{gap: "7px"}}>
                <div className="w-100 mt-3">
                    <Tabs tabs={[
                        {   
                            show: true, 
                            text: "Por territorio", 
                            value: "porTerritorio", 
                            icon: "fas fa-users",
                            component: <PorTerritorio 
                                control={control}
                                canales={canales} 
                                tipologias={tipologias} 
                                segmentacionesProveedores={segmentacionesProveedores}
                                paises={paises}
                                agencias={agencias}
                                distribuidoras={distribuidoras}
                                zonas={zonas}
                                setObjetivos={setObjetivos}
                                objetivos={objetivos}
                            />
                        },
                        {
                            show: true, 
                            text: `Por punto de venta`, 
                            value: "porPuntoVenta", 
                            icon: "fas fa-user",
                            component: <PorPuntoVenta
                                control={control}
                                negocios={negocios}
                                setObjetivos={setObjetivos}
                                objetivos={objetivos}
                            />
                        },
                        {
                            show: true, 
                            text: `Por segmentación`, 
                            value: "porSegmentacion", 
                            icon: "fas fa-users-cog",
                            component: <PorSegmentacion
                                control={control}
                                segmentaciones={segmentaciones}
                                setObjetivos={setObjetivos}
                                objetivos={objetivos}
                            />
                        }
                    ]} defaultValue="porTerritorio" />
                </div>

                <div className="w-75 pl-3 d-flex flex-column">
                    <span style={{fontSize: "11pt", fontWeight: "bold", marginBottom: "10px"}}>Objetivos de envio</span>
                    {objetivos.length > 0 ?
                        getNameObjetivosDeEnvio(objetivos).map((item, index) => {
                            return (
                                <div key={index} className="w-100 row m-0 p-0 pl-3 d-flex align-items-center position-relative" style={{height: "40px"}}>
                                    <span className="d-block mb-1" key={index}>
                                        <strong style={{fontSize: "16px", fontWeight: "bold", marginBottom: "5px"}}>»</strong>&nbsp;&nbsp;{item}
                                    </span>

                                    <Tooltip title="Eliminar" aria-label="eliminar" style={{marginLeft: "20px"}}>
                                        <a onClick={() => eliminarObjetivo(index)} className="icon-container-actions d-flex">
                                            <div style={{backgroundColor: Colors.ROJO_PASTEL}}/>
                                            <i style={{color: Colors.ROJO_PASTEL}} className="fas fa-trash fa-2x"/>
                                        </a>
                                    </Tooltip>
                                </div>
                            )
                        })
                        : <span style={{fontSize: "10pt", marginBottom: "10px"}}>No se han agregado objetivos de envío</span>
                    }
                </div>
            </div>  
        </div>
    )
}

const PorTerritorio = ({
    control, 
    canales, 
    tipologias, 
    segmentacionesProveedores,
    paises,
    agencias,
    distribuidoras,
    zonas,
    setObjetivos,
    objetivos
}) => {
    const changeCanal = useWatch({ control, name: 'canales' });
    const changeTipologia = useWatch({ control, name: 'tipologias' });
    const changeSegmentacion = useWatch({ control, name: 'segmentacionesProveedores' });
    const changePais = useWatch({ control, name: 'paises' });
    const changeAgencia = useWatch({ control, name: 'agencias' });
    const changeDistribuidora = useWatch({ control, name: 'distribuidoras' });
    const changeZona = useWatch({ control, name: 'zonas' });

    const addObjetivo = () => {
        let idDivisionTerritorial = getIdDivisionTerritorial()

        if(!idDivisionTerritorial) return

        if(!changeCanal || !changeTipologia || !changeSegmentacion) return

        if(objetivos.find(el => (
            (el.idDivisionTerritorial == idDivisionTerritorial) && 
            (el.canal == changeCanal.id) &&
            (el.tipologia == changeTipologia.id) &&
            (el.segmento == changeSegmentacion.id)
        ))) return

        setObjetivos([
            ...objetivos,
            {
                idDivisionTerritorial,
                canal: changeCanal.id,
                tipologia: changeTipologia.id,
                segmento: changeSegmentacion.id,
                type: 1
            }
        ])
    }

    const getIdDivisionTerritorial = () => {
        if(changeZona) return changeZona.id
        if(changeDistribuidora) return changeDistribuidora.id
        if(changeAgencia) return changeAgencia.id
        if(changePais) return changePais.id
    }

    return (
        <div className="w-100 row m-0 px-2 d-flex align-items-center position-relative" style={{gap: "7px"}}>
            <SelectFormVirtualize 
                isMulti={false}
                inputProps={{ control }}
                disabled={false}
                showId={false}
                identificador="canales"
                label="Canal"
                options={canales}
                required={false}
                className="px-2 col-3"
            />

            <SelectFormVirtualize
                isMulti={false}
                inputProps={{ control }}
                disabled={false}
                showId={false}
                identificador="tipologias"
                label="Tipología"
                options={tipologias}
                required={false}
                className="px-2 col-3"
            />

            <SelectFormVirtualize
                isMulti={false}
                inputProps={{ control }}
                disabled={false}
                showId={false}
                identificador="segmentacionesProveedores"
                label="Segmentación"
                options={segmentacionesProveedores}
                required={false}
                className="px-2 col-3"
            />

            <Tooltip title="Agregar" aria-label="agregar" style={{marginLeft: "10px", position: "absolute", top: "10%", right: "3.5%"}} >
                <a onClick={addObjetivo} className="icon-container-actions d-flex">
                    <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-plus fa-2x"/>
                </a>
            </Tooltip>

            <div className="w-100">
                <div className="w-100 row m-0 d-flex align-items-center mt-3">
                    <SelectFormVirtualize 
                        isMulti={false}
                        inputProps={{ control }}
                        disabled={false} 
                        showId={false} 
                        identificador="paises" 
                        label="País"
                        options={paises} 
                        required={false} 
                        className="px-2 col-3"
                    />

                    <SelectFormVirtualize 
                        isMulti={false} 
                        inputProps={{ control }} 
                        disabled={false} 
                        showId={false} 
                        identificador="agencias" 
                        label="Agencia"
                        options={agencias.filter(ag => ag.territorio_padre == changePais?.id)}
                        required={false} 
                        className="px-2 col-3"
                    />

                    <SelectFormVirtualize 
                        isMulti={false} 
                        inputProps={{ control }} 
                        disabled={false} 
                        showId={false} 
                        identificador="distribuidoras" 
                        label="Distribuidora"
                        options={distribuidoras.filter(dst => dst.territorio_padre == changeAgencia?.id)} 
                        required={false} 
                        className="px-2 col-3"
                    />

                    <SelectFormVirtualize 
                        isMulti={false} 
                        inputProps={{ control }} 
                        disabled={false} 
                        showId={false} 
                        identificador="zonas" 
                        label="Zona"
                        options={zonas.filter(z => z.territorio_padre == changeDistribuidora?.id)} 
                        required={false} 
                        className="px-2 col-3"
                    />
                </div>
            </div>
        </div>
    )
}

const PorPuntoVenta = ({control, negocios, setObjetivos, objetivos}) => {
    const [loading, setLoading] = useState(false)
    const [dataCliente, setDataCliente] = useState({idCliente : "", idNegocio: "", nombre: ""})

    const changeCliente = useWatch({ control, name: 'idCliente' });
    const changeNegocio = useWatch({ control, name: 'negocios' });

    useEffect(() => {
        const executeEffect = async () => {
            if(changeCliente && changeNegocio ) {
                setLoading(true)
                const res = await clientesService.findClienteNombre({idCliente: changeCliente, idNegocio: changeNegocio.id})
                setLoading(false)

                if(res.data.length > 0) {
                    setDataCliente({idCliente : changeCliente, idNegocio: changeNegocio.id, nombre: res.data[0].nombre})
                    return
                }
            }
            setDataCliente({idCliente : "", idNegocio: "", nombre: ""})
        }
        executeEffect()
    }, [changeCliente, changeNegocio])

    const addObjetivo = () => {
        if(changeCliente == "" || !changeNegocio) return

        if(objetivos.find(el => (el.idCliente == changeCliente && el.idNegocio == changeNegocio.id))) return
        
        setObjetivos([...objetivos, {idCliente: changeCliente, idNegocio: changeNegocio.id, type: 2}])
    }

    return (
        <div className="w-100 row m-0 px-2 d-flex align-items-center position-relative" style={{gap: "7px"}}>
            <SelectFormVirtualize 
                isMulti={false} 
                inputProps={{ control }} 
                disabled={false} 
                showId={true} 
                identificador="negocios" 
                label="Negocio"
                options={negocios} 
                required={false} 
                className="px-2 col-3"
            />

            <InputForm
                inputProps={{ control }}
                identificador="idCliente" 
                label="ID Cliente"
                placeholder=""
                required={false}
                textUppercase={false}
                className={`${classResponsiveFormDoubleWidth}`}
            />

            <Tooltip title="Agregar" aria-label="agregar" style={{marginLeft: "10px"}} >
                <a onClick={addObjetivo} className="icon-container-actions d-flex">
                    <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-plus fa-2x"/>
                </a>
            </Tooltip>

            {loading && <i 
                style={{color: Colors.COLOR_BLUE_THEME, animation: "spin 1s ease-in infinite"}} 
                className="ml-2 fas fa-circle-notch fa-2x"/>}

            <div className="w-100 mt-2">
                <span style={{fontSize: "11pt", fontWeight: "bold", marginBottom: "10px"}}>Punto de venta encontrado:</span>
                {dataCliente.idCliente != "" 
                    ? <span className="ml-2" style={{display: "block"}}>{dataCliente.idCliente}_{dataCliente.nombre}</span>
                    : <span className="ml-2" style={{display: "block"}}>No se ha encontrado ningún punto de venta</span>
                }
            </div>
        </div>
    )
}

const PorSegmentacion = ({ control, segmentaciones, setObjetivos, objetivos }) => {

    const changeSegmentacion = useWatch({
        control,
        name: 'segmentaciones'
    });

    const addObjetivo = () => {
        if(changeSegmentacion == undefined) return

        if(objetivos.find(el => el.idSegmentacion == changeSegmentacion.id)) return
        
        setObjetivos([...objetivos, {idSegmentacion: changeSegmentacion.id, type: 3}])
    }

    return (
        <div className="w-100 row m-0 px-2 d-flex align-items-center position-relative" style={{gap: "7px"}}>
            <SelectFormVirtualize 
                isMulti={false}
                inputProps={{ control }}
                disabled={false}
                showId={false}
                identificador="segmentaciones" 
                label="Segmentación"
                options={segmentaciones} 
                required={false}
                className="px-2 col-5"
            />
            
            <Tooltip title="Agregar" aria-label="agregar" style={{marginLeft: "10px"}} >
                <a onClick={addObjetivo} className="icon-container-actions d-flex">
                    <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                    <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-plus fa-2x"/>
                </a>
            </Tooltip>
        </div>
    )
}

export default FormCRUDBanners;